import { AppThunk } from '../../../store/rootReducer';
import { booleanPreferenceSelector } from '../../auth/selectors/auth.selectors';
import { SAVE_PAGE } from '../analytics.constants';
import { getBaseProperties, track } from '../analytics.utils';

export const trackSingleSaveButton =
  (sendToAnalytics = track): AppThunk =>
  (_, getState) => {
    const save_diagnostic = booleanPreferenceSelector('allowSaveDiagnostic')(
      getState(),
    );
    const save_delineation = booleanPreferenceSelector('allowSaveDelineation')(
      getState(),
    );
    const baseProperties = getBaseProperties(getState);
    if (baseProperties == null) {
      return null;
    }
    const { ecgId, userId, view } = baseProperties;

    sendToAnalytics({
      name: SAVE_PAGE,
      properties: {
        user_id: userId,
        view,
        ecg_id: ecgId,
        save_diagnostic,
        save_delineation,
      },
    });
  };
